module.exports = __webpack_public_path__ + "static/img/w_12.3eb2f650.jpg";